import { useState, useEffect } from 'react';

// Detects whether a product photo was shot on a white studio background.
// White-background shots render 'contain' on a white canvas (seamless, the
// Amazon/affiliate-site standard); edge-to-edge lifestyle shots render
// 'cover' so they fill the frame. Results cached per URL.
const fitCache = new Map();

function detectFit(src) {
  if (fitCache.has(src)) return Promise.resolve(fitCache.get(src));
  return new Promise((resolve) => {
    const done = (mode) => {
      fitCache.set(src, mode);
      resolve(mode);
    };
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const size = 24;
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, size, size);
        ctx.drawImage(img, 0, 0, size, size);
        const data = ctx.getImageData(0, 0, size, size).data;
        let border = 0;
        let white = 0;
        for (let y = 0; y < size; y++) {
          for (let x = 0; x < size; x++) {
            if (x === 0 || y === 0 || x === size - 1 || y === size - 1) {
              border++;
              const i = (y * size + x) * 4;
              if (data[i] > 235 && data[i + 1] > 235 && data[i + 2] > 235) white++;
            }
          }
        }
        done(white / border >= 0.55 ? 'contain' : 'cover');
      } catch {
        done('contain'); // CORS-tainted canvas: safe clean default
      }
    };
    img.onerror = () => done('contain');
    img.src = src;
  });
}

export const SmartProductImage = ({ src, alt, onError, imgClassName = '' }) => {
  const [mode, setMode] = useState(fitCache.get(src) || 'contain');

  useEffect(() => {
    let active = true;
    setMode(fitCache.get(src) || 'contain');
    detectFit(src).then((m) => {
      if (active) setMode(m);
    });
    return () => {
      active = false;
    };
  }, [src]);

  return (
    <div className="w-full h-full bg-white overflow-hidden">
      <img
        src={src}
        alt={alt}
        className={`w-full h-full ${mode === 'contain' ? 'object-contain p-2' : 'object-cover'} ${imgClassName}`}
        onError={onError}
      />
    </div>
  );
};
